import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidacionsesionService {

  private token: string;

  constructor() { 
    this.token = window.localStorage.getItem('token') || '';
  }

  isSessionActive(): boolean {
    return !!this.token;
  }

  clearSession(): void {
    localStorage.removeItem('authToken');
  }
  
}



